"use client";

import { IconArrowUpRight } from "central-icons-outlined/IconArrowUpRight";
import Link from "next/link";
import { useRouter } from "next/navigation";
import DemoFooter from "@/components/preview/demo-footer";
import DemoHint from "@/components/preview/demo-hint";
import DemoSplit from "@/components/preview/demo-split";
import DemoWrapper from "@/components/preview/demo-wrapper";
import ResultPanel from "@/components/preview/result-panel";

const HREF = "/cheat-sheet#accessibility";
const LABEL = "Link";

const CONTROL_CLASSNAME =
  "flex h-10 w-fit cursor-pointer select-none items-center gap-1.5 rounded-full bg-preview-bg pr-3.5 pl-4 font-medium text-base text-gray-1200 no-underline shadow-custom transition-transform duration-200 ease-out will-change-transform active:scale-[0.97]";

function ControlContent() {
  return (
    <>
      {LABEL}
      <IconArrowUpRight className="size-4.5 text-gray-1000" />
    </>
  );
}

export default function AccessibilityNativeElementsDemo() {
  const router = useRouter();

  return (
    <DemoWrapper margin="">
      <DemoSplit stackBelow="sm">
        <ResultPanel
          bad
          innerClassName="h-48 flex-col gap-6 px-6"
          label="<div>"
        >
          <div
            aria-hidden="true"
            className={CONTROL_CLASSNAME}
            onClick={() => router.push(HREF)}
          >
            <ControlContent />
          </div>

          <p className="sr-only">
            This side is the same link built from a div with a click handler.
            Without an href the browser cannot open it in a new tab, offer it in
            the right-click menu, preview its address on hover or list it as a
            link.
          </p>
        </ResultPanel>

        <ResultPanel innerClassName="h-48 flex-col gap-6 px-6" label="<a>">
          <Link className={CONTROL_CLASSNAME} href={HREF}>
            <ControlContent />
          </Link>
        </ResultPanel>
      </DemoSplit>
      <DemoFooter>
        <DemoHint>
          Try a middle click, a right click and a Cmd-click on each one
        </DemoHint>
      </DemoFooter>
    </DemoWrapper>
  );
}
